<script setup>
import DataSource from 'devextreme/data/data_source'

import ArrayStore from 'devextreme/data/array_store'
import { DxSelectBox } from 'devextreme-vue'
import { DxTextBox } from 'devextreme-vue'

import ChipStatus from '@/components/shared/ChipStatus.vue'

import { useWebSiteStore } from '@/stores/web-site.store'

const webSiteStore = useWebSiteStore()

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  isPortal: {
    type: Boolean,
    default: false,
  },
  showClearButton: {
    type: Boolean,
    default: false,
  },
  value: {
    type: Number,
    default: null,
  },
})

const defaultDataSource = new DataSource({
  store: new ArrayStore({
    data: webSiteStore.getLocalizedDocumentRowTypes(),
    key: 'id',
  }),
})

const emit = defineEmits({
  valueChanged: (e) => true,
})

const onValueChanged = (e) => {
  const newValue = e?.value ?? null
  props.data?.setValue(newValue)
  emit('valueChanged', { value: newValue, event: e })
}
</script>

<template>
  <dx-select-box
    :value="props.value"
    :data-source="defaultDataSource"
    display-expr="name"
    value-expr="id"
    :input-attr="{ 'aria-label': 'Templated Status' }"
    field-template="field"
    item-template="item"
    @value-changed="onValueChanged"
  >
    <template #field="{ data: cellInfo }">
      <ChipStatus :data="webSiteStore.getLocalizedDocumentRowTypes().find(x => x.id === cellInfo?.id)" />
      <dx-text-box
        value=""
        :read-only="true"
      />
    </template>

    <template #item="{ data: cellInfo }">
      <ChipStatus :data="webSiteStore.getLocalizedDocumentRowTypes().find(x => x.id === cellInfo?.id)" />
    </template>
  </dx-select-box>
</template>
